import React from 'react'
import { RouteComponentProps, withRouter } from 'react-router-dom'
import { IShopByCompany } from '@cbgms/api'
import navigation from 'utils-support/navigation'
import ShopCard from './ShopCard'
import { useTranslation } from 'react-i18next'
import { Box, Button, Grid, Typography } from '@mui/material'
import AddIcon from '@mui/icons-material/Add'

interface IDashboardProps {
  shops: IShopByCompany[]
}

interface Props extends RouteComponentProps<{ companyUUID?: string }>, IDashboardProps {}

const Dashboard: React.FC<Props> = ({ match, shops }) => {
  const { t } = useTranslation()

  return (
    <>
      <Box sx={{ display: 'flex', marginBottom: 2 }}>
        <Typography variant='h5' sx={{ flex: '1  1 auto', marginRight: 1 }}>
          {t('Company.ShopSegmentHeader')}
        </Typography>
        <Button
          color='primary'
          variant='contained'
          startIcon={<AddIcon />}
          onClick={() => navigation.push(`/companies/${match.params.companyUUID}/shops/new`)}
          data-testid='add-shop-btn'
        >
          {t('Company.AddShop')}
        </Button>
      </Box>

      <Grid container spacing={2}>
        {shops.map((shop, key) => (
          <Grid item xs={3} key={key}>
            <ShopCard {...shop} />
          </Grid>
        ))}
      </Grid>
    </>
  )
}

export default withRouter(Dashboard)
